import 'babel-polyfill';
import { createApp } from 'vue';
window['_'] = require('lodash');
window.Clipboard = require('clipboard');
window['Choices'] = require('choices.js');
window['Popper'] = require('popper.js').default;
window['Pikaday'] = require('pikaday');
window['store'] = require('store');
window['beautify'] = require('beautify');
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { defaultMeters } from '../common/metrics';
import VueTagsInput from '@johmun/vue-tags-input';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import ContentListComponent from './components/ContentListComponent.vue';
import GroupBuilderComponent from './components/GroupBuilderComponent.vue';
import GroupListComponent from './components/GroupListComponent.vue';
import ContentBuilderComponent from './components/ContentBuilderComponent.vue';
import FacilitatorComponent from './components/Facilitator.vue';
import LeaderboardComponent from './components/Leaderboard.vue';
import AssistantFieldsComponent from "./components/AssistantFields.vue";
import FeedbackAssistantSelector from "./components/AssistantSelector.vue";
import UsageComponent from "./components/charts/Usage.vue";
window['QuillEditor'] = QuillEditor;
window['defaultMeters'] = defaultMeters;
window['VueSelect'] = vSelect;
window['contentBuilderComponent'] = ContentBuilderComponent;
window['facilitatorComponent'] = FacilitatorComponent;
window['contentListComponent'] = ContentListComponent;
window['groupListComponent'] = GroupListComponent;
window['assistantFieldsComponent'] = AssistantFieldsComponent;
require('dom4');
window['createApp'] = createApp;
const app = createApp({});
app.component('group-builder', GroupBuilderComponent);
app.component('facilitator', FacilitatorComponent);
app.component('leaderboard', LeaderboardComponent);
app.component('assistant-fields', AssistantFieldsComponent);
app.component('feedback-assistant-selector', FeedbackAssistantSelector);
app.component('chart-usage', UsageComponent);
app.component('input-tag', VueTagsInput);
window['App'] = app;
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window['$'] = window['jQuery'] = require('jquery');
    require('bootstrap');
    require('fontawesome-iconpicker');
    require('select2');
}
catch (e) {
}
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window['axios'] = require('axios');
window['axios'].defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience, so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window['axios'].defaults.headers.common['X-CSRF-TOKEN'] = token['content'];
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
